import initSlickSlider from '../utils/initSlickSlider';
import { COMMON_SLICK_SLIDER_OPTIONS, BREAKPOINT } from '../utils/constants';

const selectors = {
    slider: '.js-our-clients-slider',
    slide: '.js-our-clients-slide',
    dotsContainer: '.js-slick-slider-navigation-dots',
    sliderWrapper: '.js-our-clients-slider-parent',
    prevArrow: '.js-slick-slider-prev-btn',
    nextArrow: '.js-slick-slider-next-btn'
};

const ourClientsSlider = () => {
    const $slider = $(selectors.slider);

    if (!$slider) {
        return;
    }

    const prevArrow = $slider.closest(selectors.sliderWrapper).find(selectors.prevArrow);
    const nextArrow = $slider.closest(selectors.sliderWrapper).find(selectors.nextArrow);
    const dotsContainer = $slider.closest(selectors.sliderWrapper).find(selectors.dotsContainer);

    const options = $.extend({}, COMMON_SLICK_SLIDER_OPTIONS, {
        prevArrow,
        nextArrow,
        appendDots: dotsContainer,
        responsive: [
            {
                breakpoint: BREAKPOINT.TABLET - 1,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: BREAKPOINT.DESKTOP - 1,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });

    initSlickSlider($slider, options);
};
export default ourClientsSlider;
